import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import DesignerPage from '~/pages/designers/[uid]'

import getDesignerPageStaticPropsFunction from '~/data/designer-page-data'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

export default DesignerPage

export const getStaticProps = getDesignerPageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: true,
  type: STORYBLOK_TYPES.DESIGNER,
  maxPathsInProduction: 10,
})
